import React, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import MollierPlot from "./MollierPlot";
import TuneIcon from "@mui/icons-material/Tune";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Input from "@mui/material/Input";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Divider, Tooltip, Typography } from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { weatherCtx } from "../../utils/hooks/mollierWeatherContext";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import {
  updateAirflow,
  changeIndoorPoint,
  changeOutdoorPoint,
} from "../../actions/summerPointsActions";
import {
  updateAirflowWinter,
  changeIndoorPointWinter,
  changeOutdoorPointWinter,
} from "../../actions/winterPointsActions";
import { handleKeyPressOnlyNumbers } from "../../utils/validationFunctions";
import { checkPercetage } from "../../utils/validationFunctions";
import { calculateAirPressure } from "../../utils/calculationFunctions";

function ChartConfigPanel({
  handleConfigChange,
  handleAxisChange,

  DBMollier,
  handleGeneratePdf,
  isSmallScreen,
}) {
  const { summerWeather } = useContext(weatherCtx);
  const summerPoints = useSelector((state) => state.processPoint.summerPoints);
  const winterPoints = useSelector((state) => state.winterPoints.winterPoints);
  const comfortZoneTempOffset = 2;
  const comfortZoneHumidityOffset = 10;
  const { chartConfig, setChartConfig } = useContext(weatherCtx);
  const { t } = useTranslation();
  const theme = useTheme();
  const indoorPoint = useSelector(
    (state) => state.processPoint.summerPoints
  ).filter((item) => item.process === "indoor")[0];
  const indoorPointWinter = useSelector(
    (state) => state.winterPoints.winterPoints
  ).filter((item) => item.process === "indoor")[0];

  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const applySettings = () => {
    handleClose();
    setChartConfig((prev) => {
      return {
        ...prev,
        minAbsoluteHumidity: localMinAbsoluteHumidity,
        maxAbsoluteHumidity: localMaxAbsoluteHumidity,
        minTemp: localMinTemp,
        maxTemp: localMaxTemp,
      };
    });
    handleAxisChange();
  };
  const [localAltitude, setLocalAltutude] = useState(chartConfig.altitude);
  const [localAirflow, setLocalAirflow] = useState(chartConfig.airflow);
  const [localMixingRatio, setLocalMixingRatio] = useState(
    chartConfig.mixingRatio
  );
  const [localMinTemp, setLocalMinTemp] = useState(chartConfig.minTemp);
  const [localMaxTemp, setLocalMaxTemp] = useState(chartConfig.maxTemp);
  const [localMinAbsoluteHumidity, setLocalMinAbsoluteHumidity] = useState(
    chartConfig.minAbsoluteHumidity
  );
  const [localMaxAbsoluteHumidity, setLocalMaxAbsoluteHumidity] = useState(
    chartConfig.maxAbsoluteHumidity
  );
  useEffect(() => {
    setLocalAltutude(chartConfig.altitude);
    setLocalMinTemp(chartConfig.minTemp);
    setLocalMaxTemp(chartConfig.maxTemp);
    setLocalMinAbsoluteHumidity(chartConfig.minAbsoluteHumidity);
    setLocalMaxAbsoluteHumidity(chartConfig.maxAbsoluteHumidity);
    setLocalAirflow(chartConfig.airflow);
    setLocalMixingRatio(chartConfig.mixingRatio);
    /*summerWeather
      ? dispatch(
          updateAirflow(localAirflow, chartConfig.airflowUnit, localMixingRatio)
        )
      : dispatch(
          updateAirflowWinter(
            localAirflow,
            chartConfig.airflowUnit,
            localMixingRatio
          )
        );*/
  }, [chartConfig]);
  const handleSettingsChange = () => {
    const newAirPressure = calculateAirPressure(+localAltitude);
    setChartConfig((prev) => {
      return { ...prev, altitude: localAltitude, airPressure: newAirPressure };
    });
    handleAxisChange();
  };

  const handleMixingRatio = () => {
    setChartConfig((prev) => {
      return { ...prev, airflow: localAirflow, mixingRatio: localMixingRatio };
    });
    let outdoorAirFlow = Math.round(+localAirflow * (+localMixingRatio / 100));
    let indoorAirFlow = Math.round(
      +localAirflow * ((100 - +localMixingRatio) / 100)
    );
    /* dispatch(
      updateAirflow(localAirflow, chartConfig.airflowUnit, localMixingRatio)
    );*/

    dispatch(changeOutdoorPoint("airFlowHours", outdoorAirFlow));
    dispatch(changeOutdoorPointWinter("airFlowHours", outdoorAirFlow));
    dispatch(changeIndoorPoint("airFlowHours", indoorAirFlow));
    dispatch(changeIndoorPointWinter("airFlowHours", indoorAirFlow));

    /*  dispatch(
      updateAirflowWinter(
        localAirflow,
        chartConfig.airflowUnit,
        localMixingRatio
      )
    );*/
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Paper p={2}>
        <Grid
          container
          spacing={1}
          alignItems="center"
          justifyContent="center"
          direction="row"
        >
          <Grid item xs={2} ml={4}>
            <Tooltip title={t("mollier.changeChartConf")}>
              <IconButton
                aria-label="delete"
                onClick={handleClickOpen}
                size="large"
              >
                <TuneIcon
                  fontSize="large"
                  /*sx={{
                  fontSize: "32px",
                  marginLeft: "38px",
                  marginBottom: "16px",
                }}*/
                />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={4} md={2}>
            <TextField
              label={t("createproject.elevation")}
              id="outlined-start-adornment"
              // sx={{ m: 1, width: "25ch" }}
              name="altitude"
              disabled={DBMollier}
              value={localAltitude}
              InputProps={{
                endAdornment: <InputAdornment position="end">m</InputAdornment>,
              }}
              /*onChange={(event) => {
                setChartConfig((prev) => {
                  return { ...prev, altitude: event.target.value };
                });
              }}*/
              onChange={(e) => {
                setLocalAltutude(e.target.value);
              }}
              onBlur={handleSettingsChange}
              onKeyPress={handleKeyPressOnlyNumbers}
            />
          </Grid>

          <Grid item xs={4} md={2.5}>
            <TextField
              label={t("mollier.airFlow")}
              id="outlined-start-adornment"
              name="airflow"
              disabled={DBMollier}
              value={localAirflow}
              // sx={{ m: 1, width: "25ch" }}
              /*InputProps={{
                endAdornment: (
                  <InputAdornment position="end">m³/h</InputAdornment>
                ),
              }}*/
              onChange={(e) => {
                setLocalAirflow(e.target.value);
              }}
              onBlur={handleMixingRatio}
              onKeyPress={handleKeyPressOnlyNumbers}
              inputProps={{
                min: 0,
                max: 100,
                step: 1,
              }}
              InputProps={{
                endAdornment: (
                  <TextField
                    id="standard-select-currency"
                    select
                    //label="Outdoor airflow"
                    //defaultValue="EUR"
                    // helperText="Please select your currency"
                    name="indoorAirFlowUnit"
                    disabled={DBMollier}
                    value={chartConfig.airflowUnit}
                    variant="standard"
                    sx={{ minWidth: "50px" }}
                    onChange={(e) => {
                      setChartConfig((prev) => {
                        return {
                          ...prev,
                          airflowUnit: e.target.value,
                        };
                      });
                    }}
                  >
                    <MenuItem key={10} value={10}>
                      m3/h
                    </MenuItem>
                    <MenuItem key={20} value={20}>
                      m3/s
                    </MenuItem>
                  </TextField>
                ),
              }}
            />
          </Grid>
          <Grid item xs={3} md={1.5}>
            <TextField
              label={t("mollier.mixingRatio")}
              id="outlined-start-adornment"
              name="mixingRatio"
              disabled={DBMollier}
              value={localMixingRatio}
              // sx={{ m: 1, width: "25ch" }}

              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
              onChange={(e) => {
                checkPercetage(e.target.value)
                  ? setLocalMixingRatio(e.target.value)
                  : setLocalMixingRatio(100);
              }}
              onBlur={handleMixingRatio}
              onKeyPress={handleKeyPressOnlyNumbers}
            />
          </Grid>

          <Grid item xs={1}>
            <Tooltip title={t("mollier.generate")}>
              <IconButton
                aria-label="pdfBtn"
                size="large"
                sx={{
                  mt: 1,
                  p: 1.8,
                  //mb: 4,
                  backgroundColor: "rgba(0, 0, 0, 0.9)",
                  color: theme.palette.secondary.main,
                  borderRadius: 1,
                  position: "relative",
                  bottom: "5px",

                  //padding: "0.5rem 0.9rem 1.2rem 0.9rem",
                  //fontSize: 14,
                  //transition: "all 0.5s",
                  "&:hover": {
                    color: theme.palette.secondary.main,
                    backgroundColor: "rgba(0, 0, 0, 0.9)",
                    transform: "scale(1.05)",
                  },
                }}
                onClick={() => {
                  handleGeneratePdf();
                }}
              >
                <PictureAsPdfIcon fontSize="medium" />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Paper>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("mollier.chartConf")}
        </DialogTitle>
        <DialogContent>
          <Paper p={2}>
            <Grid
              container
              spacing={1}
              alignItems="center"
              justifyContent="space-evenly"
              direction="row"
            >
              <Grid item xs={12}>
                <Typography>{t("mollier.absHumAxis")}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  label="Min:"
                  id="outlined-start-adornment"
                  type="number"
                  name="minAbsoluteHumidity"
                  value={localMinAbsoluteHumidity}
                  // sx={{ m: 1, width: "25ch" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">g/kg</InputAdornment>
                    ),
                  }}
                  inputProps={{
                    min: 0,
                    maxLength: 2,
                    step: 1,
                  }}
                  onChange={(e) => {
                    setLocalMinAbsoluteHumidity(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  label="Max:"
                  id="outlined-start-adornment"
                  type="number"
                  name="maxAbsoluteHumidity"
                  value={localMaxAbsoluteHumidity}
                  // sx={{ m: 1, width: "25ch" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">g/kg</InputAdornment>
                    ),
                  }}
                  inputProps={{
                    maxLength: 2,
                    step: 1,
                  }}
                  onChange={(e) => {
                    setLocalMaxAbsoluteHumidity(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography>{t("mollier.tempAxis")}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  label="Min:"
                  id="outlined-start-adornment"
                  type="number"
                  name="minTemp"
                  value={localMinTemp}
                  // sx={{ m: 1, width: "25ch" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">°C</InputAdornment>
                    ),
                  }}
                  //  onChange={handleConfigChange}
                  onChange={(e) => {
                    setLocalMinTemp(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  label="Max:"
                  id="outlined-start-adornment"
                  type="number"
                  name="maxTemp"
                  value={localMaxTemp}
                  // sx={{ m: 1, width: "25ch" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">°C</InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    setLocalMaxTemp(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography>{t("mollier.comfortArea")}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  label={`${t("mollier.relHumLow")}:`}
                  id="outlined-start-adornment"
                  type="number"
                  disabled
                  name="comfortZoneMinHumidity"
                  value={
                    summerWeather
                      ? indoorPoint.relativeHumidity - comfortZoneHumidityOffset
                      : indoorPointWinter.relativeHumidity -
                        comfortZoneHumidityOffset
                  }
                  // sx={{ m: 1, width: "25ch" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                  }}
                  onChange={handleConfigChange}
                />
              </Grid>
              <Grid item xs={5} mr={1}>
                <TextField
                  label={`${t("mollier.relHumHigh")}:`}
                  id="outlined-start-adornment"
                  type="number"
                  disabled
                  name="comfortZoneMaxHumidity"
                  value={
                    summerWeather
                      ? indoorPoint.relativeHumidity + comfortZoneHumidityOffset
                      : indoorPointWinter.relativeHumidity +
                        comfortZoneHumidityOffset
                  }
                  // sx={{ m: 1, width: "25ch" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                  }}
                  onChange={handleConfigChange}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  label="T1:"
                  id="outlined-start-adornment"
                  type="number"
                  name="t1"
                  disabled
                  value={
                    summerWeather
                      ? indoorPoint.temperatureDryBulb - comfortZoneTempOffset
                      : indoorPointWinter.temperatureDryBulb -
                        comfortZoneTempOffset
                  }
                  // sx={{ m: 1, width: "25ch" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">°C</InputAdornment>
                    ),
                  }}
                  onChange={handleConfigChange}
                />
              </Grid>

              <Grid item xs={2}>
                <TextField
                  label="T2:"
                  id="outlined-start-adornment"
                  type="number"
                  disabled
                  // sx={{ m: 1, width: "25ch" }}
                  name="t2"
                  value={
                    summerWeather
                      ? indoorPoint.temperatureDryBulb + comfortZoneTempOffset
                      : indoorPointWinter.temperatureDryBulb +
                        comfortZoneTempOffset
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">°C</InputAdornment>
                    ),
                  }}
                  onChange={handleConfigChange}
                />
              </Grid>

              <Grid item xs={2}>
                <TextField
                  label="T3:"
                  id="outlined-start-adornment"
                  type="number"
                  name="t3"
                  disabled
                  value={
                    summerWeather
                      ? indoorPoint.temperatureDryBulb + comfortZoneTempOffset
                      : indoorPointWinter.temperatureDryBulb +
                        comfortZoneTempOffset
                  }
                  // sx={{ m: 1, width: "25ch" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">°C</InputAdornment>
                    ),
                  }}
                  onChange={handleConfigChange}
                />
              </Grid>

              <Grid item xs={2}>
                <TextField
                  label="T4:"
                  id="outlined-start-adornment"
                  type="number"
                  disabled
                  name="t4"
                  value={
                    summerWeather
                      ? indoorPoint.temperatureDryBulb - comfortZoneTempOffset
                      : indoorPointWinter.temperatureDryBulb -
                        comfortZoneTempOffset
                  }
                  // sx={{ m: 1, width: "25ch" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">°C</InputAdornment>
                    ),
                  }}
                  onChange={handleConfigChange}
                />
              </Grid>
            </Grid>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t("mollier.cancel")}</Button>
          <Button onClick={applySettings} autoFocus>
            {t("mollier.apply")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default ChartConfigPanel;
